import { doPostSSRLogs } from 'yoda-core-components/lib/helpers/Utils/Utils';
import ApplicationLogger from '../helpers/ApplicationLogger';

const logger = ApplicationLogger.getLogger();

const serverSideLogging = (serverSideLogs, cookies, cluster) => {
    const { ssrSuccessful, ssrData } = serverSideLogs;
    __SERVER__ &&
        doPostSSRLogs(
            logger,
            {
                requestInfo: `IS LISTING PAGE RENDERED ON SERVER SIDE : ${ssrSuccessful}`,
                response: ssrData,
            },
            cookies,
            cluster
        );
};

export default serverSideLogging;
